export const normalizeMarkdownText = (value = "") =>
  String(value)
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(/[\s:*]+$/g, "")
    .trim();

export const includesAnyPhrase = (value, phrases = []) => {
  const normalizedValue = normalizeMarkdownText(value);

  return phrases.some((phrase) =>
    normalizedValue.includes(normalizeMarkdownText(phrase))
  );
};
